// src/context/store.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../utils/api';

// ─── Auth Store ───────────────────────────────────────────────
export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: async (email, password, otpCode = null) => {
        const { data } = await api.post('/auth/login', { email, password, otpCode });
        if (data.requires2FA) return { requires2FA: true };
        localStorage.setItem('fl_token', data.accessToken);
        localStorage.setItem('fl_refresh', data.refreshToken);
        set({ user: data.user, token: data.accessToken, isAuthenticated: true });
        return data;
      },

      register: async (payload) => {
        const { data } = await api.post('/auth/register', payload);
        localStorage.setItem('fl_token', data.accessToken);
        localStorage.setItem('fl_refresh', data.refreshToken);
        set({ user: data.user, token: data.accessToken, isAuthenticated: true });
        return data;
      },

      logout: () => {
        localStorage.removeItem('fl_token');
        localStorage.removeItem('fl_refresh');
        set({ user: null, token: null, isAuthenticated: false });
      },

      isAdmin: () => ['admin', 'superadmin'].includes(get().user?.role)
    }),
    { name: 'fl_auth', partialize: s => ({ user: s.user, isAuthenticated: s.isAuthenticated }) }
  )
);

// ─── Cart Store ───────────────────────────────────────────────
export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      codePromo: null,
      remise: 0,

      addItem: (product, taille, couleur, quantite = 1) => {
        const items = get().items;
        const key = `${product.id}-${taille}-${couleur}`;
        const existing = items.find(i => i.key === key);
        if (existing) {
          set({ items: items.map(i => i.key === key ? { ...i, quantite: i.quantite + quantite } : i) });
        } else {
          set({ items: [...items, { key, product, taille, couleur, quantite }] });
        }
      },

      removeItem: (key) => set({ items: get().items.filter(i => i.key !== key) }),

      updateQty: (key, quantite) => {
        if (quantite < 1) return get().removeItem(key);
        set({ items: get().items.map(i => i.key === key ? { ...i, quantite } : i) });
      },

      applyPromo: (code, remise) => set({ codePromo: code, remise }),
      clearPromo: () => set({ codePromo: null, remise: 0 }),
      clearCart: () => set({ items: [], codePromo: null, remise: 0 }),

      subtotal: () => get().items.reduce((s, i) => {
        const prix = i.product.prix_promo || i.product.prix;
        return s + prix * i.quantite;
      }, 0),

      total: () => Math.max(0, get().subtotal() - get().remise),
      count: () => get().items.reduce((s, i) => s + i.quantite, 0)
    }),
    { name: 'fl_cart' }
  )
);
